import { redoStyle, undoStyle } from './styleHandling';
import {
  redoColors,
  redoLogo,
  redoPattern,
  redoText,
  toolbarActive,
  undoColors,
  undoLogo,
  undoText,
} from './webGL';

export function updateUndoState(undoList) {
  if (!Array.isArray(undoList) || typeof window.setUndoState !== 'function') return;
  if (undoList.length === 0) {
    window.setUndoState(false);
    return;
  }
  if (toolbarActive.value === 'logo' && window.decals.length === 0) {
    window.setUndoState(false);
    return;
  }
  if (toolbarActive.value === 'style' && undoList.length === 1) {
    window.setUndoState(false);
    return;
  }
  if (toolbarActive.value === 'text' && undoList.length === 0) {
    window.setUndoState(false);
    return;
  }
  if (toolbarActive.value === 'pattern' && undoList.length === 0) {
    window.setUndoState(false);
    return;
  }
  if (toolbarActive.value === 'color' && undoList.length === 0) {
    window.setUndoState(false);
    return;
  }
  window.setUndoState(true);
}

export function updateRedoState(redoList) {
  if (!Array.isArray(redoList) || typeof window.setRedoState !== 'function') return;

  if (redoList.length === 0) window.setRedoState(false);
  else window.setRedoState(true);
}

export function updateClearState() {
  if (typeof window.setClearState !== 'function') return;

  if (undoLogo && undoLogo.length > 0) {
    window.setClearState(true);
    return;
  }

  if (undoColors && undoColors.length > 0) {
    window.setClearState(true);
    return;
  }

  if (window.undoPatterns && window.undoPatterns.length > 0) {
    window.setClearState(true);
    return;
  }

  if (undoStyle && undoStyle.length > 0) {
    window.setClearState(true);
    if (toolbarActive.value === 'logo' && window.decals.length === 0) {
      window.setClearState(false);
    }
    if (toolbarActive.value === 'color') {
      window.setClearState(false);
    }
    if (toolbarActive.value === 'pattern') {
      window.setClearState(false);
    }
    if (toolbarActive.value === 'text' && undoText.length === 0) {
      window.setClearState(false);
    }
    return;
  }

  if (undoText && undoText.length > 0) {
    window.setClearState(true);
    return;
  }

  window.setClearState(false);
}

export function handleToolbarChanged(newValue) {
  switch (newValue) {
    case 'style':
      updateRedoState(redoStyle);
      updateUndoState(undoStyle);
      break;
    case 'logo':
      updateRedoState(redoLogo);
      updateUndoState(undoLogo);
      break;
    case 'color':
      updateRedoState(redoColors);
      updateUndoState(undoColors);
      break;
    case 'pattern':
      updateRedoState(redoPattern);
      updateUndoState(window.undoPatterns);
      break;
    case 'text':
      updateRedoState(redoText);
      updateUndoState(undoText);
      break;
    default:
      console.log('ERROR');
  }
}

export function createArrayWithLengthCallback(initialArray = [], callback) {
  return new Proxy(initialArray, {
    set(target, property, value) {
      const oldLength = target.length;
      target[property] = value;
      const newLength = target.length;

      if (oldLength !== newLength) {
        callback(newLength, oldLength, target);
      }

      return true;
    },
  });
}

export class ObservableValue {
  constructor(value) {
    this.listeners = [];
    this._value = value;
  }

  addListener(listener, scope) {
    const boundListener = scope ? listener.bind(scope) : listener;
    this.listeners.push(boundListener);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== boundListener);
    };
  }

  removeListener(listener) {
    this.listeners = this.listeners.filter((currentListener) => currentListener !== listener);
  }

  removeListenerBaseOnName(listener) {
    this.listeners = this.listeners.filter(
      (currentListener) => !currentListener.name.includes(listener.name),
    );
  }

  notify(data) {
    this.listeners.forEach((listener) => {
      if (typeof listener === 'function') {
        listener(data);
      }
    });
  }

  get value() {
    return this._value;
  }

  set value(newValue) {
    if (this._value === newValue) return;
    this._value = newValue;
    this.notify(newValue);
  }
}
